import React, { useCallback } from 'react';
import { ArrowDownLine } from 'lib/lucky-x-icons';
import classNames from 'classnames';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setCurExpandProject } from 'store/features/projectDetailSlice';

interface IShowMoreProps {
  id: number;
  openShowMore: boolean;
  toggleOpenShowMore: (open: boolean) => void;
  getProjectWhitelistRaffle: (isUpdate?: boolean) => void;
}

const ShowMoreIcon: React.FC<IShowMoreProps> = ({
  id,
  openShowMore,
  toggleOpenShowMore,
  getProjectWhitelistRaffle,
}) => {
  const dispatch = useAppDispatch();
  const { curExpandProject } = useAppSelector((state) => state.projectDetail);

  const handleOpenShowMore = useCallback(() => {
    if (curExpandProject !== id) {
      getProjectWhitelistRaffle();
      dispatch(setCurExpandProject(id));
      toggleOpenShowMore(true);
    } else {
      toggleOpenShowMore(!openShowMore);
    }
  }, [
    curExpandProject,
    dispatch,
    getProjectWhitelistRaffle,
    id,
    openShowMore,
    toggleOpenShowMore,
  ]);

  return (
    <div
      className=" group flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-neutral-600 hover:border-neutral-100"
      onClick={handleOpenShowMore}
    >
      <ArrowDownLine
        size={24}
        className={classNames('text-neutral-400 group-hover:text-neutral-100', {
          'rotate-180': openShowMore && id === curExpandProject,
        })}
      />
    </div>
  );
};

export default ShowMoreIcon;
